angular.module('core')
  .service('transformResponse', ['minutesFilter', '$rootScope', 'moment', function($minutesFilter, $rootScope, $moment) {

    var transformResponseToJson = function(body, headersGetter, status) {
      try {
        var jsonBody = JSON.parse(body);
        return jsonBody.data;
      } catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var transformResponseAndReportDates = function(body, headersGetter, status) {
      try {
        var jsonBody = JSON.parse(body);
        transformReportDates(jsonBody);
        return jsonBody.data;
      } catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };


    var transformErrors = function(JSONObj) {
      if (typeof JSONObj !== 'undefined' && JSONObj.errors !== null && typeof JSONObj.errors !== 'undefined') {
        var errors = $rootScope.errors || [];
        _.each(JSONObj.errors, function(item) {
          errors.push(item);
        });
        $rootScope.errors = errors;
      }
    };

    var transformReportDates = function(jsonBody) {
      if (typeof jsonBody !== 'undefined' && jsonBody.report_dates !== null && typeof jsonBody.report_dates !== 'undefined') {
        $rootScope.reportDates = jsonBody.report_dates;
        return jsonBody.report_dates;
      }
      return null;
    };

    var getTypeInResponse = function(type) {
      switch (type) {
        case 'guardian':
          return 'customer';
        default:
          return type;
      }
    };

    var transformJson = function(responseType, jsonBody, item_mapping, optionalItemType) {
      var result;
      var JSONObj;
      var typeInResponse = getTypeInResponse(responseType);
      var itemType = optionalItemType ? optionalItemType : responseType;

      try {
        JSONObj = jsonBody.data;
        result = JSONObj[typeInResponse + 's'];

        result = _.map(result, function(item) {
          item.type = itemType;
          if (item.status !== null) {
            item.warn = item.status === 2;
            item.congratulate = item.status === 1;
          }
          item_mapping(item);

          return item;
        });
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        result = [];
      }

      transformErrors(JSONObj);
      return result;
    };

    var transformMatrix = function(body) {
      var result;
      var JSONObj;

      var jsonBody = JSON.parse(body);

      try {
        JSONObj = jsonBody.data;
        result = JSONObj;
      }
      catch(e) {
        result = [];
      }

      transformErrors(JSONObj);
      return result;
    };

    var transform = function(type, body, item_mapping) {
      try {
        var jsonBody = JSON.parse(body);
        return transformJson(type, jsonBody, item_mapping);
      }
      catch(e) {
        console.error('Transform Error:', e.message);
      }
      return [];
    };

    var transformActivitiesQuery = function(type, body, item_mapping, httpStatus) {
        try {
            var jsonBody = JSON.parse(body);
            var events = transformJson(type, jsonBody, item_mapping);

            return {events: events, reportDates: jsonBody.report_dates , links: jsonBody.data.links};
        }
        catch(e) {
            console.error('Transform Error:', e.message);
        }
        return {events: []};
    };

    var transformAggregationQuery = function(type, body, item_mapping, itemType) {
        try {
            var jsonBody = JSON.parse(body);
            var list = transformJson(type, jsonBody, item_mapping, itemType);
            transformReportDates(jsonBody);

            return {list: list, totals: jsonBody.totals, reportDates: jsonBody.report_dates , links: jsonBody.data.links};
        }
        catch(e) {
            console.error('Transform Error:', e.message);
        }
        return {list: [], totals:{}};
    };

    var transformQuery = function(type, body, item_mapping) {
      return transform(type, body, item_mapping);
    };

    var transformReportingQuery = function(type, body, item_mapping, httpStatus) {
      try {
        var jsonBody = JSON.parse(body);
        transformReportDates(jsonBody);
        return transformJson(type, jsonBody, item_mapping);
      }
      catch(e) {
        console.error('Transform Error:', e.message);
      }
      return [];
    };

    var transformGet = function(type, body, item_mapping) {
      var result = transform(type, body, item_mapping);
      return _.first(result);
    };

    var transformAssignedLessonGet = function(type, body, item_mapping) {
      // From @Renee: @John, for the GET API, if you want to show only the most recent assignment,
      // show the one with the max assignment_id.  That should always be the latest.

      // @TODO: Eventually we're going to need check STATUS member as well
      var result = transform(type, body, item_mapping);
      return _.max(result, function(assignment){return assignment.assignment_id;});
    };

    var transformHighlights = function(body, headersGetter, status) {
      var result = {}, highlights;
      try {
        var jsonBody = JSON.parse(body);
        highlights = jsonBody.data;
        result.years = highlights.reporting_years;
        result.activeStudents = highlights.count_active_students;
        result.averageWeeklySessionTime = $minutesFilter(highlights.average_weekly_session_time);
        result.averageMonthlySessionTime = $minutesFilter(highlights.average_monthly_session_time);
        result.lessonsCompletedThisYear = highlights.count_lessons_completed;
        result.countLessonsCompleted = highlights.count_lessons_completed;
        result.countLessonsCompletedByActiveStudents = highlights.count_lessons_completed_by_active_students;
        result.countLessonsCompletedStatus = highlights.count_lessons_completed_status;
        result.extendedUsage = highlights.percent_usage_extended_hours;
        result.percentGrowth = highlights.percent_growth;
        result.percentGrowthStatus = highlights.percentGrowthStatus;
        result.standardsAchieved = highlights.standards_growth;
        result.standardsAchievedNames = highlights.standards_growth_names;
        result.description = highlights.narrative;
        result.grades = highlights.grade_label;
        result.city = highlights.city;
        result.state = highlights.region;
        result.image_url = highlights.image_url + '?v=' + $moment().valueOf();
        if (highlights.status !== null) {
          result.congratulate = highlights.status === 1;
          result.warn = highlights.status === 2;
        }
        result.status_reason_codes = highlights.status_reason_codes;
      }
      catch(e) {
        console.error('Highlight Transform Error:', e.message);
        result = {};
      }
      return result;
    };

      var transformAssignments = function(body) {
          var result = {};
          try {
              var parsed = JSON.parse(body);
              if (parsed.data !== null) {
                  result = parsed.data;
              }
          }
          catch(e) {
              console.error('Assignments Transform Error:', e.message);
              result = [];
          }
          return result;
      };

    var transformStandards = function(body, type, mapping, status) {
      var result = {};
      try {
        var parsed = JSON.parse(body);
        transformReportDates(parsed);
        if (parsed.data !== null) {
          result = parsed.data;
          result = mapping(type, result);
        }
      }
      catch(e) {
        console.error('Standards Transform Error:', e.message);
        result = [];
      }
      return result;
    };

    var transformBubbleGraph = function(type, body, mapping) {
      var result = {};
      try {
        result = JSON.parse(body).data;
        result.clusters.forEach(function(cluster, clusterIndex) {

          cluster.items = _.map(cluster.items, function(item) {
            item.type = type;
            item.warn = item.status === 2;
            item.congratulate = item.status === 1;
            mapping(item);

            return item;
          });

        });
      }
      catch(e) {
        console.error('Bubble Graph Transform Error:', e.message);
        result = [];
      }

      return result;
    };

    return {
      transformResponseToJson: transformResponseToJson,
      transformResponseAndReportDates: transformResponseAndReportDates,
      transformNavigationQuery: transformQuery,
      transformManagementGet: transformQuery,
      transformNavigationGet: transformGet,
      transformGeographyGet: transformGet,
      transformGeographyQuery: transformQuery,
      transformStandardsQuery: transformQuery,
      transformHighlights: transformHighlights,
      transformStandards: transformStandards,
      transformReportingQuery: transformReportingQuery,
      transformAssignmentsQuery: transformAssignments,
      transformActivitiesQuery: transformActivitiesQuery,
      transformBubbleGraph: transformBubbleGraph,
      transformReportDates: transformReportDates,
      transformAssignedLessonGet: transformAssignedLessonGet,
      transformAssignmentStatusQuery: transformQuery,
      transformDemoLessonMappingsQuery: transformQuery,
      transformPrimaryStandards: transformMatrix,
      transformAssignedLessonQuery: transformGet,
      transformStudentClassrooms: transformQuery,
      transformAggregationQuery:transformAggregationQuery
    };

  }]);
